import axios from "axios";
import { BACKEND_URL, api } from "./api";

const KEY = "fa-guest";

export const isGuest = () => sessionStorage.getItem(KEY) === "1";

const setGuestBase = () => { api.defaults.baseURL = `${BACKEND_URL}/api/guest`; };

if (isGuest()) setGuestBase();

export const enterGuest = async (token) => {
  const { data } = await axios.post(`${BACKEND_URL}/api/guest/session`, { token }, { withCredentials: true });
  sessionStorage.setItem(KEY, "1");
  sessionStorage.setItem("fa-guest-name", data.name);
  setGuestBase();
  return data;
};

const enter = (data) => {
  sessionStorage.setItem(KEY, "1");
  sessionStorage.setItem("fa-guest-name", data.name);
  setGuestBase();
  return data;
};

export const enterGuestByUsername = async (username) =>
  enter((await axios.post(`${BACKEND_URL}/api/guest/login`, { username }, { withCredentials: true })).data);

// coarse device fingerprint (abuse blocking only)
const fingerprint = async () => {
  const raw = [navigator.userAgent, navigator.language, screen.width, screen.height, screen.colorDepth, Intl.DateTimeFormat().resolvedOptions().timeZone, navigator.hardwareConcurrency].join("|");
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(raw));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("").slice(0, 32);
};

export const startGuestSignup = async (username, email, website) =>
  (await axios.post(`${BACKEND_URL}/api/guest/signup/start`, { username, email, website, fp: await fingerprint(), loaded_ms: Math.round(performance.now()) })).data;

export const verifyGuestSignup = async (email, code) =>
  enter((await axios.post(`${BACKEND_URL}/api/guest/signup/verify`, { email, code }, { withCredentials: true })).data);

export const guestSignupOn = async () => {
  try { return (await axios.get(`${BACKEND_URL}/api/guest/signup-config`)).data.enabled; } catch { return false; }
};

export const leaveGuest = async () => {
  try { await api.post("/logout"); } catch { /* cookie already gone */ }
  sessionStorage.removeItem(KEY);
  sessionStorage.removeItem("fa-guest-name");
  api.defaults.baseURL = `${BACKEND_URL}/api`;
};

export const guestName = () => sessionStorage.getItem("fa-guest-name") || "Guest";
